export enum EventMedium {
  Fisico = 1,
  Virtuale = 2,
  Free = 3,
}
